module.exports = __webpack_public_path__ + "img/95.9faf81b6.jpg";